import { render, staticRenderFns } from "./LoadingInTheBackground.vue?vue&type=template&id=2a1a0fda&scoped=true"
import script from "./LoadingInTheBackground.vue?vue&type=script&lang=js"
export * from "./LoadingInTheBackground.vue?vue&type=script&lang=js"
import style0 from "./LoadingInTheBackground.vue?vue&type=style&index=0&id=2a1a0fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a0fda",
  null
  
)

export default component.exports